import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { AbstractPage } from '../abstract-page';

@Component({
  selector: "page-staff-confirm-password-modal",
  templateUrl: "staff-confirm-password-modal.html",
})
export class StaffConfirmPasswordModalPage extends AbstractPage {
  password: string;

  constructor(public viewController: ViewController) {
    super();
  }

  confirm() {
    if (this.password !== 'hanaito') {
      alert("パスワードが違います");
      return;
    }
    this.viewController.dismiss();
    return;
  }
}



// WEBPACK FOOTER //
// ./src/pages/_com/staff-confirm-password-modal/staff-confirm-password-modal.ts